import ApiUtils from 'api/ApiUtils';
import moment from 'moment';
import React, {useEffect, useState} from 'react';

import {Dropdown} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {fetchNotifications} from 'slices/notification/thunk';
import {
  markNotificationsAsRead,
  updateNotificationCount,
} from 'slices/notification/reducer';
import {type AppDispatch} from 'store';

const NotificationList = (): React.JSX.Element => {
  // const dispatch = useDispatch();
  const dispatch = useDispatch<AppDispatch>();
  const notifications = useSelector(
    (state: any) => state.notificationState.notifications,
  );
  const hasNewNotification = useSelector(
    (state: any) => state.notificationState.hasNewNotification,
  );
  const notificationCount = useSelector(
    (state: any) => state.notificationState.notificationCount,
  );
  const [notificationCounterLocal, setNotificationCounterLocal] = useState();
  // console.log('🚀 ~ notificationCounterLocal:', notificationCounterLocal);
  // const handleOpenNotifications = (): any => {
  //   dispatch(markNotificationsAsRead()); // Reset flag when opened
  //   console.log('test-----');
  //   void dispatch(fetchNotifications());
  // };

  const handleOpenNotifications = (): any => {
    dispatch(markNotificationsAsRead()); // Reset flag when opened
    void dispatch(fetchNotifications()); // Ensure correct dispatch type
  };
  useEffect(() => {
    setNotificationCounterLocal(notificationCount);
  }, [notificationCount]);

  const [readNotifications, setReadNotifications] = useState<string[]>([]);

  // const fetchNotifications = async (): Promise<void> => {
  //   await ApiUtils.getNotificationlList()
  //     .then(async (data: any): Promise<void> => {
  //       setNotifications(data?.data); // Update state with fetched notifications
  //       setHasNewNotification(false); // Reset new notification indicator
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };

  // useEffect(() => {
  //   void fetchNotifications();
  // }, []);

  // On bell icon click
  // const handleBellClick = async (): Promise<void> => {
  //   if (notifications.length === 0 || hasNewNotification) {
  //     void fetchNotifications(); // Fetch only if notifications are empty or there are new ones
  //   }
  // };

  const getNotificationLink = (type: number): string => {
    // console.log('parsedType', type);
    switch (type) {
      case 1:
        return 'events';
      case 2:
        return 'guests';
      case 3:
        return 'booktable';
      case 5:
        return 'restaurantbooktable';
      default:
        return 'users';
    }
  };

  // onMessage(messaging, payload => {
  //   // toast(<Message notification={payload.notification} />);
  //   void fetchNotifications();
  //   console.log('Lets fetch again in Notification list!!');
  // });

  const handleNotificationClick = async (
    notificationId: any,
  ): Promise<void> => {
    try {
      const response: any = await ApiUtils.updateNotificationStatus({
        id: notificationId,
      });
      setReadNotifications(prev => [...prev, notificationId]);

      dispatch(updateNotificationCount(response?.data?.notificationCount));

      setNotificationCounterLocal(response?.data?.notificationCount);
    } catch (error: any) {}
  };

  return (
    <>
      <Dropdown className="ms-sm-3 header-item topbar-user notification-bg">
        {/* <Dropdown.Toggle
          type="button"
          className="btn bg-transparent border-0 arrow-none "
          id="page-header-user-dropdown">
          <span
            className="d-flex align-items-center text-dark"
            onClick={handleOpenNotifications}
            style={{position: 'relative'}}>
            <i className="fa-lg bi bi-bell fs-4"></i>

            {notificationCount > 0 && Boolean(hasNewNotification) ? (
              <span
                style={{
                  color: 'red',
                  fontWeight: 'bold',
                  position: 'absolute',
                  left: '13px',
                  top: '-4px',
                }}>
                {notificationCount}
              </span>
            ) : (
              <span
                style={{
                  color: 'red',
                  fontWeight: 'bold',
                  position: 'absolute',
                  left: '13px',
                  top: '-4px',
                }}>
                {notificationCounterLocal}
              </span>
            )}
          </span>
        </Dropdown.Toggle> */}
        <Dropdown.Toggle
          type="button"
          className="btn bg-transparent border-0 arrow-none"
          id="page-header-user-dropdown">
          <span
            className="d-flex align-items-center text-dark position-relative"
            onClick={handleOpenNotifications}>
            {/* Bell Icon */}
            <i className="bi bi-bell fs-4"></i>

            {/* Notification Badge for local or new notifications */}
            {(notificationCount > 0 || Boolean(hasNewNotification)) && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
                style={{
                  fontSize: '10px',
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                }}>
                {/* Display either notification count or local count */}
                {notificationCount > 0
                  ? notificationCount
                  : notificationCounterLocal}
              </span>
            )}
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-end">
          {/* <div
            className="dropdown-menu notification-ui_dd show"
            aria-labelledby="navbarDropdown">
            <div className="notification-ui_dd-header">
              <h3 className="text-center">Notification</h3>
            </div>
            <div className="notification-ui_dd-content">
              <div className="notification-list notification-list--unread">
                <div className="notification-list_img">
                  <img src="https://i.imgur.com/zYxDCQT.jpg" alt="user" />
                </div>
                <div className="notification-list_detail">
                  <p>
                    <b>John Doe</b> reacted to your post
                  </p>
                  <p>
                    <small>10 mins ago</small>
                  </p>
                </div>
                <div className="notification-list_feature-img">
                  <img
                    src="https://i.imgur.com/AbZqFnR.jpg"
                    alt="Feature image"
                  />
                </div>
              </div>
              <div className="notification-list notification-list--unread">
                <div className="notification-list_img">
                  <img src="https://i.imgur.com/w4Mp4ny.jpg" alt="user" />
                </div>
                <div className="notification-list_detail">
                  <p>
                    <b>Richard Miles</b> reacted to your post
                  </p>
                  <p>
                    <small>1 day ago</small>
                  </p>
                </div>
                <div className="notification-list_feature-img">
                  <img
                    src="https://i.imgur.com/AbZqFnR.jpg"
                    alt="Feature image"
                  />
                </div>
              </div>
              <div className="notification-list">
                <div className="notification-list_img">
                  <img src="https://i.imgur.com/ltXdE4K.jpg" alt="user" />
                </div>
                <div className="notification-list_detail">
                  <p>
                    <b>Brian Cumin</b> reacted to your post
                  </p>
                  <p>
                    <small>1 day ago</small>
                  </p>
                </div>
                <div className="notification-list_feature-img">
                  <img
                    src="https://i.imgur.com/bpBpAlH.jpg"
                    alt="Feature image"
                  />
                </div>
              </div>
              <div className="notification-list">
                <div className="notification-list_img">
                  <img src="https://i.imgur.com/CtAQDCP.jpg" alt="user" />
                </div>
                <div className="notification-list_detail">
                  <p>
                    <b>Lance Bogrol</b> reacted to your post
                  </p>
                  <p>
                    <small>1 day ago</small>
                  </p>
                </div>
                <div className="notification-list_feature-img">
                  <img
                    src="https://i.imgur.com/iIhftMJ.jpg"
                    alt="Feature image"
                  />
                </div>
              </div>
            </div>
            <div className="notification-ui_dd-footer">
              <a href="#!" className="btn btn-success btn-block">
                View All
              </a>
            </div>
          </div> */}
          <div
            className="dropdown-menu notification-ui_dd show"
            aria-labelledby="navbarDropdown">
            <div className="notification-ui_dd-header">
              <h3 className="text-center">Notification</h3>
            </div>
            <div className="notification-ui_dd-content">
              {notifications.map((notification: any): any => {
                const isRead =
                  notification?.status === 3 ||
                  readNotifications.includes(notification?.id);
                return (
                  <Link
                    key={notification.id}
                    to={`/${getNotificationLink(notification.type)}`}
                    className="notification-link"
                    onClick={async () => {
                      await handleNotificationClick(notification?.id);
                    }}>
                    <div
                      key={notification.id}
                      className={`notification-list ${
                        isRead
                          ? 'notification-list--read'
                          : 'notification-list--unread'
                      }`}>
                      {/* <div className="notification-list_img">
                      <img src={'https://via.placeholder.com/50'} />
                    </div> */}
                      <div className="notification-list_detail">
                        <p>
                          <b>{notification.userName}</b> {notification.title}{' '}
                          {isRead && <i className="bi bi-check-all"></i>}
                        </p>
                        <p>
                          <small>
                            <i className="bi bi-clock"></i>{' '}
                            {moment(notification?.updated_at).format(
                              'Do MMM, YYYY hh:mm A',
                            )}
                          </small>
                        </p>
                      </div>
                      {/* <div className="notification-list_feature-img">
                      <img
                        src={'https://via.placeholder.com/100'}
                        alt="Feature"
                      />
                    </div> */}
                    </div>
                  </Link>
                );
              })}
            </div>
            {/* <div className="notification-ui_dd-footer">
              <a href="#!" className="btn btn-success btn-block">
                View All
              </a>
            </div> */}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NotificationList;
